import React from "react";
import { ModalBody } from "reactstrap";

export default function TechBaseModalBody({ children }) {
  return <ModalBody className="techbase-dialog-content">{children}</ModalBody>;
}
